<template>
  <ContentWrapperControl
    no_bottom
    full_width
    class="h-screen bg-white flex flex-col items-center overflow-hidden z-poll papsi-poll pb-4"
  >
    <div
      class="bg-primary w-full flex flex-col items-center flex-shrink-0"
      style="height: 105px"
    >
      <div class="flex items-center w-full mt-4 px-3">
        <img
          src="@/assets/icons/papsi_arrow_back_alt.svg"
          alt="Back"
          class="w-5 h-5 cursor-pointer"
        />

        <div class="flex-1 flex justify-center">
          <img :src="getLogoPath()" class="w-24" />
        </div>

        <div class="w-5"></div>
      </div>

      <div class="flex justify-center mt-4">
        <div
          v-for="n in 3"
          @click="index = n"
          :key="n"
          class="w-8 h-8 flex items-center justify-center rounded-full text-white font-bold"
          :class="[
            index === n ? 'bg-secondary-dark' : '',
            n !== 3 ? 'mr-3' : '',
          ]"
          :style="index === n ? '' : 'background-color: rgba(255,255,255,0.2)'"
        >
          {{ n }}
        </div>
      </div>
    </div>
    <div
      v-if="index === 1"
      class="flex-1 w-full overflow-y-auto px-6 mt-6 max-w-md"
    >
      <div>
        <span class="font-bold text-primary text-left">{{
          this.lang("lbl_0000255")
        }}</span>
        <div class="flex flex-col mt-4">
          <FormTextControl
            class="mb-4"
            v-model="personal_info.lname"
            name="lname"
            :placeholder="lang('lbl_0000145')"
            required
            uppercase
          />
          <FormTextControl
            class="mb-4"
            v-model="personal_info.fname"
            name="fname"
            :placeholder="lang('lbl_0000146')"
            required
            uppercase
          />
          <FormTextControl
            class="mb-4"
            v-model="personal_info.suffix"
            name="suffix"
            :placeholder="lang('lbl_0000385')"
            required
            uppercase
          />
          <FormTextControl
            class="mb-4"
            v-model="personal_info.mname"
            name="mname"
            :placeholder="lang('lbl_0000325')"
            required
            uppercase
          />

          <ComboboxControl
            class="mb-4"
            name="gender"
            :placeholder="lang('lbl_0000104')"
            :options="getLookup('gender')"
            v-model="personal_info.gender"
            required
          />
          <ComboboxControl
            class="mb-4"
            name="marital_status"
            :placeholder="lang('lbl_0000440')"
            :options="getLookup('marital_status')"
            v-model="personal_info.marital_status"
            required
          />

          <FormTextControl
            class="mb-4"
            v-model="personal_info.date_of_birth"
            name="date_of_birth"
            :placeholder="lang('lbl_0000105')"
            type="date"
            required
            uppercase
          />

          <ComboboxControl
            class="mb-4"
            name="country_of_birth"
            :placeholder="lang('lbl_0000441')"
            :options="getLookup('country')"
            v-model="personal_info.country_of_birth"
            required
          />

          <FormTextControl
            class="mb-4"
            v-model="personal_info.place_of_birth"
            name="place_of_birth"
            :placeholder="lang('lbl_0000390')"
            required
            uppercase
          />

          <ComboboxControl
            class="mb-4"
            name="nationality"
            :placeholder="lang('lbl_0000391')"
            :options="getLookup('nationality')"
            v-model="personal_info.nationality"
            required
          />

          <ComboboxControl
            class="mb-4"
            name="city"
            :placeholder="lang('lbl_0000442')"
            :options="getGenders"
            v-model="personal_info.city"
            required
          />
          <ComboboxControl
            class="mb-4"
            name="province"
            :placeholder="lang('lbl_0000396')"
            :options="getGenders"
            v-model="personal_info.province"
            required
          />
          <ComboboxControl
            class="mb-4"
            name="barangay"
            :placeholder="lang('lbl_0000443')"
            :options="getGenders"
            v-model="personal_info.barangay"
            required
          />

          <FormTextControl
            class="mb-4"
            v-model="personal_info.street"
            name="street"
            :placeholder="lang('lbl_0000394')"
            required
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="personal_info.house_number"
            name="house_number"
            :placeholder="lang('lbl_0000393')"
            required
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="personal_info.zip_code"
            name="zip_code"
            :placeholder="lang('lbl_0000399')"
            required
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="personal_info.tin"
            name="tin"
            :placeholder="lang('lbl_0000098')"
            required
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="personal_info.gsis_sss"
            name="gsis_sss"
            :placeholder="lang('lbl_0000444')"
            required
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="personal_info.reason"
            name="reason"
            :placeholder="lang('lbl_0000445')"
            required
          />

          <FormTextControl
            class="mb-4"
            v-model="personal_info.mobile_number"
            name="mobile_number"
            :placeholder="lang('lbl_0000007')"
            required
          />

          <FormTextControl
            class="mb-4"
            v-model="personal_info.residence_contact_number"
            name="residence_contact_number"
            :placeholder="lang('lbl_0000446')"
            required
          />

          <FormTextControl
            class="mb-4"
            v-model="personal_info.email_address"
            name="email_address"
            :placeholder="lang('lbl_0000005')"
            required
          />
        </div>
      </div>
      <div class="mt-4">
        <span class="font-bold text-primary text-left">{{
          this.lang("lbl_0000447")
        }}</span>
        <div class="flex flex-col mt-4">
          <FormTextControl
            class="mb-4"
            v-model="additional_info.purpose_of_stay"
            name="purpose_of_stay"
            :placeholder="lang('lbl_0000448')"
            required
            uppercase
          />
          <FormTextControl
            class="mb-4"
            v-model="additional_info.type_of_visa"
            name="type_of_visa"
            :placeholder="lang('lbl_0000449')"
            required
            uppercase
          />
          <FormTextControl
            class="mb-4"
            v-model="additional_info.length_of_stay"
            name="length_of_stay"
            :placeholder="lang('lbl_0000450')"
            required
            uppercase
          />
          <FormTextControl
            class="mb-4"
            v-model="additional_info.frequency_of_visit"
            name="frequency_of_visit"
            :placeholder="lang('lbl_0000451')"
            required
            uppercase
          />
          <FormTextControl
            class="mb-4"
            v-model="additional_info.specify_purpose"
            name="specify_purpose"
            :placeholder="lang('lbl_0000452')"
            required
            uppercase
          />
          <FormTextControl
            class="mb-4"
            v-model="additional_info.affiliation"
            name="affiliation"
            :placeholder="lang('lbl_0000453')"
            required
            uppercase
          />
        </div>
      </div>
      <div class="flex flex-row mt-4">
        <ButtonControl
          class="flex-1 mr-2"
          :outline="true"
          @click="this.$router.push('/dashboard')"
        >
          {{ this.lang("lbl_0000181") }}</ButtonControl
        >
        <ButtonControl class="flex-1 ml-2" @click="index = 2">{{
          this.lang("lbl_0000033")
        }}</ButtonControl>
      </div>
    </div>
    <div
      v-if="index === 2"
      class="flex-1 w-full overflow-y-auto px-6 mt-6 max-w-md"
    >
      <div>
        <span class="font-bold text-primary text-left">{{
          this.lang("lbl_0000454")
        }}</span>
        <div class="flex flex-col mt-4">
          <ComboboxControl
            class="mb-4"
            name="us_resident"
            :placeholder="lang('lbl_0000455')"
            :options="getGenders"
            v-model="other_personal_info.us_resident"
            required
          />
          <ComboboxControl
            class="mb-4"
            name="us_citizen"
            :placeholder="lang('lbl_0000456')"
            :options="getGenders"
            v-model="other_personal_info.us_citizen"
            required
          />

          <FormTextControl
            class="mb-4"
            v-model="other_personal_info.us_tin"
            name="us_tin"
            :placeholder="lang('lbl_0000457')"
            type="date"
            required
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="other_personal_info.countries_of_resident"
            name="countries_of_resident"
            :placeholder="lang('lbl_0000458')"
            required
            uppercase
          />

          <span class="mb-4 font-semibold text-grey-darker">{{
            this.lang("lbl_0000459")
          }}</span>

          <FormTextControl
            class="mb-4"
            v-model="other_personal_info.name_of_pep"
            name="name_of_pep"
            :placeholder="lang('lbl_0000460')"
            required
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="other_personal_info.position"
            name="position"
            :placeholder="lang('lbl_0000461')"
            required
            uppercase
          />
        </div>
      </div>
      <div class="flex flex-row mt-4">
        <ButtonControl
          class="flex-1 mr-2"
          :outline="true"
          @click="this.$router.push('/dashboard')"
        >
          {{ this.lang("lbl_0000181") }}</ButtonControl
        >
        <ButtonControl class="flex-1 ml-2" @click="index = 3">{{
          this.lang("lbl_0000033")
        }}</ButtonControl>
      </div>
    </div>
    <div
      v-if="index === 3"
      class="flex-1 w-full overflow-y-auto px-6 mt-6 max-w-md"
    >
      <div>
        <span class="font-bold text-primary text-left">{{
          this.lang("lbl_0000462")
        }}</span>
        <div class="flex flex-col mt-4">
          <ComboboxControl
            class="mb-4"
            name="occupation"
            :placeholder="lang('lbl_0000463')"
            :options="getGenders"
            v-model="occupation_details.occupation"
            required
          />

          <FormTextControl
            class="mb-4"
            v-model="occupation_details.employer_name"
            name="employer_name"
            :placeholder="lang('lbl_0000464')"
            type="date"
            required
            uppercase
          />

          <ComboboxControl
            class="mb-4"
            name="nature_of_work"
            :placeholder="lang('lbl_0000464')"
            :options="getGenders"
            v-model="occupation_details.nature_of_work"
            required
          />

          <FormTextControl
            class="mb-4"
            v-model="occupation_details.office_contact_number"
            name="office_contact_number"
            :placeholder="lang('lbl_0000466')"
            required
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="occupation_details.office_address"
            name="office_address"
            :placeholder="lang('lbl_0000467')"
            required
            uppercase
          />
        </div>
      </div>
      <div class="mt-4">
        <span class="font-bold text-primary text-left">{{
          this.lang("lbl_0000468")
        }}</span>
        <div class="flex flex-col mt-4">
          <ComboboxControl
            class="mb-4"
            name="purpose_of_account"
            :placeholder="lang('lbl_0000469')"
            :options="getGenders"
            v-model="other_info.purpose_of_account"
            required
          />

          <FormTextControl
            class="mb-4"
            v-model="other_info.source_of_funds"
            name="source_of_funds"
            :placeholder="lang('lbl_0000412')"
            type="date"
            required
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="other_info.amount_of_initial_deposit"
            name="amount_of_initial_deposit"
            :placeholder="lang('lbl_0000470')"
            required
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="other_info.mailing_address"
            name="mailing_address"
            :placeholder="lang('lbl_0000471')"
            required
            uppercase
          />

          <ComboboxControl
            class="mb-4"
            name="source_of_wealth"
            :placeholder="lang('lbl_0000472')"
            :options="getGenders"
            v-model="other_info.source_of_wealth"
            required
          />

          <FormTextControl
            class="mb-4"
            v-model="other_info.monthly_expected_credit"
            name="monthly_expected_credit"
            :placeholder="lang('lbl_0000473')"
            required
            uppercase
          />
        </div>
      </div>
      <div class="mt-4">
        <span class="font-bold text-primary text-left">{{
          this.lang("lbl_0000474")
        }}</span>
        <div class="flex flex-col mt-4">
          <FormTextControl
            class="mb-4"
            v-model="additional_info.relationship_with_sender"
            name="relationship_with_sender"
            :placeholder="lang('lbl_0000475')"
            type="date"
            required
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="additional_info.country_where_wealth"
            name="country_where_wealth"
            :placeholder="lang('lbl_0000476')"
            required
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="additional_info.occupation_of_sender"
            name="occupation_of_sender"
            :placeholder="lang('lbl_0000477')"
            required
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="additional_info.nature_of_work_of_sender"
            name="nature_of_work_of_sender"
            :placeholder="lang('lbl_0000478')"
            required
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="additional_info.nature_of_work_of_sender"
            name="nature_of_work_of_sender"
            :placeholder="lang('lbl_0000478')"
            required
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="additional_info.purpose_of_allowance"
            name="purpose_of_allowance"
            :placeholder="lang('lbl_0000479')"
            required
            uppercase
          />

          <ComboboxControl
            class="mb-4"
            name="account_with_beneficial_owner"
            :placeholder="lang('lbl_0000480')"
            :options="getGenders"
            v-model="additional_info.account_with_beneficial_owner"
            required
          />
        </div>
      </div>
      <div class="flex flex-row mt-4">
        <ButtonControl
          class="flex-1 mr-2"
          :outline="true"
          @click="this.$router.push('/dashboard')"
        >
          {{ this.lang("lbl_0000181") }}</ButtonControl
        >
        <ButtonControl class="flex-1 ml-2" @click="index = 3">{{
          this.lang("lbl_0000033")
        }}</ButtonControl>
      </div>
    </div>
  </ContentWrapperControl>
</template>

<script>
import ContentWrapperControl from "@/components/controls/ContentWrapperControl.vue";
import FormTextControl from "@/components/controls/FormTextControl.vue";
import ComboboxControl from "@/components/controls/ComboboxControl.vue";
import ButtonControl from "@/components/controls/ButtonControl.vue";
import BAO from "@/services/BAO";
import mixin from "@/mixin";

export default {
  mixins: [mixin],
  emits: [
    "success",
    "error",
    "alert",
    "login",
    "logout",
    "showloader",
    "hideloader",
    "showblinder",
    "hideblinder",
    "terminate",
    "checkauth",
    "nofooter",
    "shownavbar",
    "hidenavbar",
    "opensidebar",
    "closed",
    "agreed",
  ],
  components: {
    ContentWrapperControl,
    ComboboxControl,
    FormTextControl,
    ButtonControl,
  },
  data() {
    return {
      index: 1,
      lookup: {
        barangays: [],
        provinces: [],
        cities: [],
        account_with_beneficial_owner: [],
        country: [],
        gender: [],
        marital_status: [],
        nationality: [],
        nature_of_work: [],
        occupation: [],
        purpose_of_the_account: [],
        source_of_wealth: [],
      },
      personal_info: {
        fname: "",
        mname: "",
        lname: "",
        gender: "",
        marital_status: "",
        date_of_birth: "",
        country_of_birth: "",
        place_of_birth: "",
        nationality: "",
        city: "",
        province: "",
        barangay: "",
        street: "",
        house_number: "",
        zip_code: "",
        tin: "",
        gsis_sss: "",
        reason: "",
        mobile_number: "",
        residence_contact_number: "",
        email_address: "",
      },
      non_filipino: {
        purpose_of_stay: "",
        type_of_visa: "",
        length_of_stay: "",
        frequency_of_visit: "",
        purpose: "",
        affiliation: "",
      },
      other_personal_info: {
        us_resident: "",
        us_citizen: "",
        us_tin: "",
        countries_of_resident: "",
        pep: {
          name: "",
          position: "",
        },
      },
      occupation_details: {
        occupation: "",
        employer_name: "",
        nature_of_work: "",
        office_contact_number: "",
        office_address: "",
      },
      other_info: {
        purpose_of_account: "",
        source_of_funds: "",
        amount_of_initial_deposit: "",
        mailing_address: "",
        source_of_wealth: "",
        monthly_expected_credit: "",
      },
      additional_info: {
        relationship_with_sender: "",
        country_where_wealth: "",
        occupation_of_sender: "",
        nature_of_work_of_sender: "",
        purpose_of_allowance: "",
        account_with_beneficial_owner: "",
      },
      other: {
        enabled_ebanking: "",
        avail_credit_card: "",
      },
    };
  },
  mounted() {
    this.$emit("checkauth");
    this.$emit("hidenavbar");
    this.$emit("nofooter", true);
    this.$emit("showloader");

    BAO.getRCBCInfo()
      .then((response) => {
        // console.log(response.data.data);

        const data = response.data.data;
        const mapToOption = (array) =>
          (array || []).map((value) => ({
            label: value,
            value: value,
          }));

        this.lookup.gender = mapToOption(data.gender);
        this.lookup.marital_status = mapToOption(data.marital_status);
        this.lookup.country = mapToOption(data.country);
        this.lookup.occupation = mapToOption(data.occupation);
        this.lookup.purpose_of_the_account = mapToOption(
          data.purpose_of_the_account,
        );
        this.lookup.source_of_wealth = mapToOption(data.source_of_wealth);
        this.lookup.account_with_beneficial_owner = mapToOption(
          data.account_with_beneficial_owner,
        );

        BAO.getProvinces()
          .then((response) => {
            this.lookup.provinces = response.data.data.map((province) => ({
              label: province.province_name,
              value: province.province_code,
            }));
          })
          .catch((error) => {
            console.error("Error fetching provinces:", error);
          })
          .finally(() => {
            this.$emit("hideloader");
          });
      })
      .catch((error) => {
        console.error("Error fetching RCBC info:", error);
      });
  },
  computed: {
    getGenders() {
      return this.lookup.gender || [];
    },
    getProvinces() {
      return this.lookup.provinces || [];
    },
    getCities() {
      return this.lookup.cities || [];
    },
  },
  methods: {
    getLookup(key) {
      return this.lookup[key] || [];
    },
    getLogoPath() {
      const path = "ga/";
      const file_name = "papsi_logo.png";
      if (process.env.VUE_APP_CDN_URL) {
        return process.env.VUE_APP_CDN_URL + path + file_name;
      }
    },
    submit() {
      return;
    },
  },
};
</script>

<style scoped>
.bg-white-20 {
  background-color: rgba(255, 255, 255, 0.2);
}
</style>
